import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useMutation } from "shared/hooks/useApi";
import { DELETE_PRICER } from "utils/api/graphql/mutations/pricers";
import { PRICERS } from "utils/api/graphql/queries/pricers";
import { INITIAL_VALUES, SCREENS } from "utils/constants";
import View from "./View";

const Delete = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [visible, setVisible] = useState(true);
  const cancel = () => navigate(SCREENS.PRIVATE.ADMIN.PRICERS.LIST.path);
  const [deletePricer] = useMutation(DELETE_PRICER, {
    refetchQueries: [
      {
        query: PRICERS,
        awaitRefetchQueries: true,
        variables: INITIAL_VALUES,
      },
      {
        query: PRICERS,
        awaitRefetchQueries: true,
      },
    ],
    onCompleted: () => {
      setVisible(false);
      navigate(SCREENS.PRIVATE.ADMIN.PRICERS.LIST.path, { replace: true });
    },
  });
  const onSubmit = () => {
    return deletePricer({
      variables: {
        where: {
          id,
        },
      },
    });
  };
  return <View onSubmit={onSubmit} cancel={cancel} visible={visible} />;
};

export default Delete;
